import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import "../styles/pages/service-detail.css";

function Recruitment() {
    return (
        <main className="page">
            <Seo
                title="Staff Recruitment and Supply"
                path="/services/recruitment"
                description="Reliable staff recruitment and supply services for care homes, supported living providers, healthcare settings, and community services."
                keywords="staff recruitment and supply, healthcare recruitment, care staffing, temporary staffing, workforce support"
            />

            <div className="container service-detail">
                <section className="recruitment-hero">
                    <div className="recruitment-hero__content">
                        <p className="eyebrow">Recruitment & Supply</p>
                        <h1>Reliable staffing support for care and healthcare environments</h1>
                        <p className="recruitment-hero__lead">
                            We support healthcare and care organizations with dependable staffing
                            solutions, helping teams stay fully resourced with qualified
                            professionals when continuity, safety, and service quality matter most.
                        </p>

                        <div className="service-hero-card__actions">
                            <Link to="/contact" className="btn btn--primary">
                                Request Staffing Support
                            </Link>
                            <Link to="/services" className="btn btn--secondary">
                                View All Services
                            </Link>
                        </div>
                    </div>

                    <aside className="recruitment-hero__aside">
                        <div className="service-highlight-box">
                            <p className="service-highlight-box__label">At a glance</p>
                            <ul className="service-highlight-box__list">
                                <li>Temporary and ongoing staffing cover</li>
                                <li>Fast turnaround recruitment</li>
                                <li>Flexible workforce planning</li>
                                <li>Qualified and vetted professionals</li>
                            </ul>
                        </div>
                    </aside>
                </section>

                <section className="recruitment-section">
                    <div className="recruitment-section__header">
                        <p className="eyebrow">What we offer</p>
                        <h2>A responsive recruitment service designed around real staffing needs</h2>
                    </div>

                    <div className="detail-grid detail-grid--feature">
                        <div className="info-card info-card--feature">
                            <h3>What We Provide</h3>
                            <p>
                                Temporary cover, long-term staffing support, targeted recruitment
                                campaigns, and flexible staffing options aligned to service demand.
                            </p>
                        </div>

                        <div className="info-card info-card--feature">
                            <h3>Who We Support</h3>
                            <p>
                                Care homes, supported living providers, healthcare settings,
                                community services, and organizations needing trusted workforce
                                solutions.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="recruitment-section">
                    <div className="recruitment-section__header">
                        <p className="eyebrow">Why organisations choose us</p>
                        <h2>Practical support, fast response, and quality-focused delivery</h2>
                    </div>

                    <div className="detail-grid detail-grid--three detail-grid--benefits">
                        <div className="info-card info-card--benefit">
                            <span className="benefit-number">01</span>
                            <h3>Fast Response</h3>
                            <p>
                                We understand urgency. Our team responds quickly to staffing gaps
                                so you can maintain continuity of care and service delivery.
                            </p>
                        </div>

                        <div className="info-card info-card--benefit">
                            <span className="benefit-number">02</span>
                            <h3>Quality Assurance</h3>
                            <p>
                                All staff are vetted, qualified, and matched carefully to your
                                service requirements, environment, and expectations.
                            </p>
                        </div>

                        <div className="info-card info-card--benefit">
                            <span className="benefit-number">03</span>
                            <h3>Flexible Solutions</h3>
                            <p>
                                Whether short-term cover or long-term staffing, we adapt to your
                                needs with scalable and reliable workforce solutions.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="service-cta service-cta--wide">
                    <p className="eyebrow">Ready to get started?</p>
                    <h2>Need reliable staff support?</h2>
                    <p>
                        Speak to our team today and we’ll help you find the right staffing
                        solution quickly, professionally, and efficiently.
                    </p>

                    <div className="service-cta__actions">
                        <Link to="/contact" className="btn btn--primary">
                            Contact Us
                        </Link>
                        <Link to="/services" className="btn btn--secondary">
                            Explore Other Services
                        </Link>
                    </div>
                </section>
            </div>
        </main>
    );
}

export default Recruitment;